<script>
import {i18nApi} from "@core/api";
import {BRow, BCol, BFormGroup, BTabs, BTab, BFormInput} from 'bootstrap-vue'
import LocalizedQuestion from "@/views/administration/substance/regulated-substances/LocalizedQuestion.vue";

export default {
    components: {
        LocalizedQuestion,
        BRow, BCol, BFormGroup, BTabs, BTab, BFormInput
    },
    props: {
        localizedQuestions: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        let questions = {};
        this.localizedQuestions.forEach(lc => {
            questions[lc.language] = {question: lc.question, language: lc.language};
        });
        return {
            languages: [],
            questions: questions,
        };
    },
    created() {
        i18nApi.getLanguages().then(r => {
            this.languages = r.data;
            this.languages.forEach(language => {
                if (!this.questions.hasOwnProperty(language.code)) {
                    this.questions[language.code] = {question: '', language: language.code};
                }
            });
        });
    },
    methods: {
        onChange(ll) {
            this.questions[ll.language] = ll;
            this.emit();
        },
        emit() {
            this.$emit(
                'input',
                Object.keys(this.questions).map(language => {
                    return {question: this.questions[language].question, language};
                })
            );
        }
    },
    watch: {
        localizedQuestions() {
            this.localizedQuestions.forEach(lc => {
                this.questions[lc.language] = {question: lc.question, language: lc.language};
            });
        }
    }
}
</script>

<template>
    <b-tabs>
        <b-tab
            v-for="language in languages"
            :title="language.code.toUpperCase()"
        >
            <b-row>
                <b-col>
                    <LocalizedQuestion
                        :language="language.code"
                        :question="questions[language.code].question"
                        @input="onChange"
                    />
                </b-col>
            </b-row>
        </b-tab>
    </b-tabs>
</template>
